export default "__VITE_ASSET__D9vwGXur__ 100w";